import { render, staticRenderFns } from "./assetsStatisticsRecord.vue?vue&type=template&id=65663a90&scoped=true"
import script from "./assetsStatisticsRecord.vue?vue&type=script&lang=js"
export * from "./assetsStatisticsRecord.vue?vue&type=script&lang=js"
import style0 from "./assetsStatisticsRecord.vue?vue&type=style&index=0&id=65663a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65663a90",
  null
  
)

export default component.exports